import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

export default function MintBatchTab({ list: { data } }) {
    return (
        <>
            <Typography
                sx={{
                    width: '100%',
                    fontWeight: '700',
                    fontSize: '36px',
                    lineHeight: '50px',
                    fontFamily: 'Circular Std',
                }}
                component="h3"
            >
                Batch minting NFT {data && data[0] ? data[0].Contract : ''}
            </Typography>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
                <Table
                    sx={{ minWidth: '100%' }}
                    size="small"
                    aria-label="a dense table"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>No</TableCell>
                            <TableCell align="right">Token&nbsp;Name</TableCell>
                            <TableCell align="right">Description</TableCell>
                            <TableCell align="right">Amount</TableCell>
                            <TableCell align="right">Price</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data
                            ? data.map((row) => (
                                    <TableRow
                                        key={row.no}
                                        sx={{
                                            '&:last-child td, &:last-child th': {
                                                border: 0,
                                            },
                                        }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.no}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row['Token Name']}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.Description}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.Amount}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.Price}
                                        </TableCell>
                                    </TableRow>
                                ))
                            : null}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
